module.exports = __webpack_public_path__ + "img/coin-right.618b2e4c.svg";